<div class="form-container">
    <div class="form-form">
        <div class="form-form-wrap">
            <div class="form-container">
                <div class="form-content">
                    <div class="text-center mb-2">
                        <img width="250" src="/assets/images/logo_2.png" alt="">
                    </div>
                    <h2 class="">
                        <a href="javascript:void(0)"><span class="brand-name">GPS eLock Service</span></a>
                    </h2>
                    <p class="signup-link mb-3">New Here? <a href="/register" style="cursor: pointer;">Create an
                            account</a></p>
                    <form class="text-left needs-validation" [formGroup]="form" id="loginForm" action="javascript:void(0);" novalidate>
                        <div class="form">

                            <div id="email-field" class="field-wrapper input">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-user">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                                <input formControlName="email" id="email" name="email" type="email" class="form-control"
                                    placeholder="Email" required>
                                <div class="invalid-feedback">
                                    Please provide the valid email
                                </div>
                            </div>

                            <div id="password-field" class="field-wrapper input mb-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-lock">
                                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                </svg>
                                <input formControlName="password" id="password" name="password" type="password"
                                    class="form-control" placeholder="Password" required>
                                <div class="invalid-feedback">
                                    Please provide the password
                                </div>
                            </div>
                            <div class="d-sm-flex justify-content-between">
                                <div class="field-wrapper toggle-pass">
                                    <p class="d-inline-block">Show Password</p>
                                    <label class="switch s-primary">
                                        <input type="checkbox" (change)="showPswd()" id="toggle-password"
                                            class="d-none">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                                <div class="field-wrapper mb-2">
                                    <button type="submit" class="btn btn-primary" id="loginButton" value="" (click)="login()">Log
                                        In</button>
                                </div>
                                <div class="field-wrapper">
                                    <button type="button" class="btn btn-dark" data-toggle="modal"
                                        data-target="#trackModal" data-backdrop="false">Track Vehicle</button>
                                </div>

                            </div>
                            <div class="mt-2">
                                <a href="javascript:void(0);" style="float: right;" data-toggle="modal"
                                    data-target="#forgetPw">
                                    <span>
                                        Forget Password?
                                    </span>
                                </a>
                            </div>

                        </div>
                    </form>


                    <p class="terms-conditions">© 2020 All Rights Reserved. <b>Transecur Telematics Pvt. Ltd</b>.</p>

                </div>
            </div>
        </div>
    </div>
    <div class="form-image">
        <div class="l-image">
        </div>
    </div>
</div>

<!-- modal-dialog-centered -->

<div class="modal fade" id="trackModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header p-2">
                <h5 class="modal-title" id="myCenterModalLabel">Track Vehicle</h5>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body" *ngIf="trackingData.length == 0">
                <form class="needs-validation" [formGroup]="trackingForm" novalidate>
                    <div class="form-row">
                        <div class="form-group col-md-12 mb-0">
                            <label for="tripID" class="col-form-label">Trip ID</label>
                            <input formControlName="tripID" type="text" class="form-control" id="tripID" required>
                            <div class="invalid-feedback">
                                Please provide the trip ID
                            </div>
                        </div>
                        <div class="form-group col-md-12 mb-0">
                            <label for="truckNo" class="col-form-label">Truck No.</label>
                            <input formControlName="truckNo" type="text" class="form-control" id="truckNo" required>
                            <div class="invalid-feedback">
                                Please provide the truck no.
                            </div>
                        </div>
                        <div class="form-group col-md-12 mb-0">
                            <label for="permitNo" class="col-form-label">Permit No.</label>
                            <input formControlName="permitNo" type="text" class="form-control" id="permitNo" required>
                            <div class="invalid-feedback">
                                Please provide the permit no.
                            </div>
                        </div>
                        <div class="form-group col-md-12 text-center">
                            <button type="button" [disabled]="!trackingForm.valid" (click)="trackNow()"
                                class="btn btn-primary waves-effect waves-light m-1 mt-2">
                                <i class="fe-check-circle mr-1"></i> Track
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-body" *ngIf="trackingData.length > 0">
                <div class="content">
                    <ul class="list-group list-group-icons-meta">
                        <li class="list-group-item list-group-item-action">
                            <div class="media">
                                <div class="d-flex mr-3"> Trip ID </div>
                                <div class="media-body text-right">
                                    <h6 class="tx-inverse">{{trackingData[0].tripID}}</h6>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item list-group-item-action">
                            <div class="media">
                                <div class="d-flex mr-3"> Truck No </div>
                                <div class="media-body text-right">
                                    <h6 class="tx-inverse">{{trackingData[0].truckNo}}</h6>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item list-group-item-action">
                            <div class="media">
                                <div class="d-flex mr-3"> Permit No </div>
                                <div class="media-body text-right">
                                    <h6 class="tx-inverse">{{trackingData[0].permitNo}}</h6>
                                </div>
                            </div>
                        </li>

                        <li class="list-group-item list-group-item-action">
                            <div class="media">
                                <div class="d-flex mr-3"> Source </div>
                                <div class="media-body text-right">
                                    <h6 class="tx-inverse">{{trackingData[0]?.geofence[0]?.name}}</h6>
                                </div>
                            </div>
                        </li>

                        <li class="list-group-item list-group-item-action">
                            <div class="media">
                                <div class="d-flex mr-3"> Destination </div>
                                <div class="media-body text-right">
                                    <h6 class="tx-inverse">{{trackingData[0]?.geofence[1]?.name}}</h6>
                                </div>
                            </div>
                        </li>

                        <li class="list-group-item list-group-item-action">
                            <div class="media">
                                <div class="d-flex mr-3"> Movement </div>
                                <div class="media-body text-right">
                                    <h6 class="tx-inverse">{{trackingData[0]?.movementType | movementType}}</h6>
                                </div>
                            </div>
                        </li>

                        <li class="list-group-item list-group-item-action">
                            <div class="media">
                                <div class="d-flex mr-3"> Transporter </div>
                                <div class="media-body text-right">
                                    <h6 class="tx-inverse">{{trackingData[0]?.transporter}}</h6>
                                </div>
                            </div>
                        </li>
                        <li class="list-group-item list-group-item-action">
                            <div class="media">
                                <div class="d-flex mr-3"> Device </div>
                                <div class="media-body text-right">
                                    <p class="mb-2" *ngFor="let item of trackingData;">
                                        <span *ngIf="item.status != 'initiated'"
                                            class="cursor-pointer badge outline-badge-secondary"
                                            (click)="goToTrack(item)"> {{item?.device?.id}} </span>
                                        <span *ngIf="item.status == 'initiated'"
                                            class="cursor-pointer badge outline-badge-warning">Trip not started
                                            yet</span>
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li class="list-group-item list-group-item-action">
                            <div>
                                <span class="d-block"><button class="btn btn-sm btn-block btn-danger"
                                        (click)="reset()">Track Another Vehicle</button></span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- forget passwrd -->
<div class="modal" id="forgetPw" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="forgetPwLabel">Forget Password</h4>
                <button type="button" class="close" (click)="this.forgetPw.reset()" data-dismiss="modal"
                    aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <form class="needs-validation" [formGroup]="getEmail" novalidate>
                    <div class="form-row">
                        <div class="form-group col-md-12 mb-0" *ngIf="!isGetOtp">
                            <input placeholder="please enter email" formControlName="email" type="email"
                                class="form-control" id="emal" required>
                            <span class="error-msg"
                                *ngIf="(getEmail.get('email')?.touched || getEmail.get('email')?.dirty) && !getEmail.get('email').valid">
                                <span *ngIf="getEmail.get('email')?.errors.required">
                                    Email is required.
                                </span>
                                <span *ngIf="getEmail.get('email')?.errors?.pattern">
                                    Please provide the Valid email.
                                </span>
                            </span>
                        </div>

                        <div class="form-group col-md-12 mb-0">
                            <button *ngIf="!isGetOtp" type="button" [disabled]="!getEmail.get('email').valid"
                                (click)="getOTP()" class="btn btn-success waves-effect waves-light m-1 mt-2">
                                <i class="fe-check-circle mr-1"></i> Submit
                            </button>
                            <!-- <a href="/forget" style="cursor: pointer; "
                                class="btn btn-success waves-effect waves-light m-1 mt-2"> Submit</a> -->
                            <!-- <button *ngIf="isGetOtp && !isOtpConfirm"  type="button" [disabled]="!getEmail.get('otp').valid" (click)="confirmOTP()"
                                class="btn btn-success waves-effect waves-light m-1 mt-2">
                                <i class="fe-check-circle mr-1"></i> Confirm OTP
                            </button> -->
                        </div>
                    </div>
                </form>
                <form class="needs-validation" *ngIf="isGetOtp" [formGroup]="forgetPw" novalidate>
                    <div class="form-row">
                        <div class="form-group col-md-12 mb-0">
                            <label for="emal" class="col-form-label">OTP</label>
                            <input (keypress)="restrictNumeric($event)" formControlName="otp" type="text"
                                class="form-control" id="emal" required>
                            <span class="error-msg" *ngIf="forgetPw.get('otp').dirty && forgetPw.get('otp').errors">
                                <span *ngIf="forgetPw.get('otp')?.errors?.required">
                                    OTP is required.
                                </span>
                            </span>
                        </div>
                        <div class="form-group col-md-12 mb-0">
                            <label for="newPassword" class="col-form-label">New Password</label>
                            <input formControlName="newPassword" type="password" class="form-control" id="newPassword">
                            <small class="error-msg"
                                *ngIf="forgetPw.get('newPassword').dirty && forgetPw.get('newPassword').errors">
                                <small *ngIf="forgetPw.get('newPassword').errors?.required">
                                    Password is required.
                                </small>
                                <small *ngIf="forgetPw.get('newPassword').errors?.pattern && !isPwMatched">
                                    Please Provide Valid Password e.g(Abc&#64;1234)
                                </small>
                            </small>
                        </div>
                        <div class="form-group col-md-12 mb-0">
                            <label for="newPassword" class="col-form-label">Confirm Password</label>
                            <input formControlName="confrmPassword" (input)="checkPassword($event)" type="password"
                                class="form-control" id="newPassword"> 
                            <small class="error-msg"
                                *ngIf="forgetPw.get('confrmPassword').dirty && forgetPw.get('confrmPassword')errors">
                                <small *ngIf="forgetPw.get('confrmPassword').errors?.required">
                                    Please Provide Confirm Password.
                                </small>
                                <small *ngIf="!isPwMatched">
                                    Password not matched.Please provide correct password
                                </small>
                            </small>
                        </div>
                        <div>
                            <small>
                                <code>
                                    Password must contain 1 uppercase, 1 lowercase, 1 special case & 1 numeric character & of minimum 8 characters e.g- Ab&#64;12345
                                </code>
                            </small>
                        </div>
                    </div>
                    <div class="form-group col-md-12 text-center"> 
                        <button type="button" [disabled]="(!forgetPw.valid || !isPwMatched)" (click)="resetPassword()"
                            class="btn btn-success waves-effect waves-light m-1 mt-2">
                            <i class="fe-check-circle mr-1"></i> Reset Password
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<button class="d-none" value="" data-toggle="modal" id="verify" data-target="#verifyOtp"> </button>
<!-- modal -->
<div class="modal" id="verifyOtp" tabindex="-1" role="dialog" style="top: 50px;" data-backdrop="static">
    <div class="modal-dialog" role="document" style="max-width: 400px;">
        <div class="modal-content">
            <form (submit)="login()">
                <div class="modal-header text-center py-1 px-2">
                    <h5 class=""></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">x</button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                        <div class="form-group col-md-12 mb-0">
                            <input placeholder="Enter OTP" minlength="6" [(ngModel)]="otp" type="text" name="otp"
                                [ngModelOptions]="{standalone: true}" class="form-control" id="otp" required>

                            <p style="text-align:end; cursor: pointer; color: #007bff;" (click)="loginOtp('resend')">
                                Resend
                                OTP?
                            </p>
                        </div>
                    </div>

                </div>
                <div class="modal-footer" style="padding-top: 10px;justify-content: center;">
                    <button type="submit" class="btn btn-secondary"
                        [disabled]="(otp == '' || otp == null)">Submit</button>
                </div>
            </form>
        </div>
    </div>
</div>